// @ is an alias to /src
import mastertime from '@/api/mastertime'

export const namespaced = true

export const state = {
  hardwareStatus: [],
  hardwareModels: [],
}

export const mutations = {
  setHardwareStatus(state, hardwareStatus) {
    state.hardwareStatus = hardwareStatus
  },

  setHardwareModels(state, hardwareModels) {
    state.hardwareModels = hardwareModels
  },
}

export const actions = {
  async fetchHardwares(_, payload) {
    const { data } = await mastertime.fetchHardwares(payload)
    const hardwares = data.data
    const totalHardwares = data.total

    return { hardwares, totalHardwares }
  },

  async fetchHardware(_, hardware_uuid) {
    const { data } = await mastertime.fetchHardware(hardware_uuid)
    const hardware = data

    return hardware
  },

  async fetchHardwareStatus({ commit }) {
    const { data } = await mastertime.fetchHardwareStatus()
    const hardwareStatus = data.data

    commit('setHardwareStatus', hardwareStatus)
  },

  async fetchHardwareModels({ commit }, payload) {
    const { data } = await mastertime.fetchHardwareModels(payload)
    const hardwareModels = data.data

    commit('setHardwareModels', hardwareModels)
  },

  async addHardware(_, hardware) {
    const { data } = await mastertime.addHardware(hardware)
    return data
  },

  async editHardware(_, hardware) {
    const { data } = await mastertime.editHardware(hardware)
    return data
  },

  async deleteHardware(_, hardware_uuid) {
    await mastertime.deleteHardware(hardware_uuid)
  },

  async unRegisterHardware(_, hardware_uuid) {
    const { data } = await mastertime.unRegisterHardware(hardware_uuid)
    return data
  },

  async checkStatusHardware({ dispatch }, hardware_uuid) {
    const hardware = await dispatch('fetchHardware', hardware_uuid)
    if (hardware.is_registered) {
      return hardware
    }
  },

  async hardwareReplicate(_, payload) {
    const { data } = await mastertime.hardwareReplicate(payload)
    return data
  },
}
